<template>
  <div>
    <div class="primary--text">{{ $t('user_beacon_type') }}</div>
    <apexchart
      :key="chartKey"
      type="area"
      height="350"
      :options="chartOptions"
      :series="series"
    ></apexchart>
  </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'
import cloneDeep from 'lodash/cloneDeep'

export default {
  components: {
    apexchart: VueApexCharts
  },
  props: ['value'],
  data() {
    return {
      chartKey: 0,
      data: null,
      series: [],
      chartOptions: {
        chart: {
          height: 350,
          type: 'area'
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          curve: 'smooth'
        },
        xaxis: {
          type: 'datetime',
          categories: []
        },
        tooltip: {
          y: {
            formatter: function (val) {
              return val
            }
          }
        }
      }
    }
  },
  watch: {
    value: {
      handler() {
        this.data = this.value
        this.transformDataRenderChart()
      },
      deep: true
    }
  },
  mounted() {
    this.data = this.value
    this.transformDataRenderChart()
  },
  methods: {
    getDataSeries(dataset) {
      let objData = {}
      Object.keys(dataset).forEach((item) => {
        const value = dataset[item]

        objData['non_friend'] = objData['non_friend'] || []
        objData['non_friend'].push(value.non_friend)

        objData['friend'] = objData['friend'] || []
        objData['friend'].push(value.friend)
      })

      const series = Object.keys(objData).map((key) => {
        return {
          name: key === 'non_friend' ? 'Banner' : 'Enter',
          data: objData[key]
        }
      })

      return series
    },
    transformDataRenderChart() {
      const vm = this
      try {
        const tempData = cloneDeep(vm.data)
        if (tempData) {
          const categories = Object.keys(tempData)
          const chartSeries = vm.getDataSeries(tempData)

          vm.chartOptions.xaxis.categories = categories
          vm.series = chartSeries
        } else {
          vm.chartOptions.xaxis.categories = []
          vm.series = []
        }
        vm.chartKey += 1
      } catch (error) {
        console.error(error)
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/Beacon/Analytics/Charts/MetricUsersByDateChart.vue